import {
  IonAvatar,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import React, { useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { AuthContext } from "../../providers/authContext";
import {
  CARD_ENROLLMENT_URL,
  HASH_URL,
  TAHSILAT_BASARILI_ONLINEODEME,
  TAHSILAT_BASARISIZ,
} from "../../services/constants";
import tahsilatService from "../../services/TahsilatService";
import { randomNumberInRange } from "../../utils";
import TahsilatHazirla from "../entities/TahsilatHazirla";
import { useLocation } from "react-router";

const OnlineBorcOdeme: React.FC = () => {
  const { kurumBilgileri, logo } = React.useContext(AuthContext);
  const { search } = useLocation<any>();

  const [refreshIFrame, setRefreshIFrame] = useState<number>(0);
  const [tahsilat, setTahsilat] = useState<TahsilatHazirla>();
  const [selectedBorc, setSelectedBorc] = useState<string>();
  const [odenecekGenelToplam, setOdenecekGenelToplam] = useState<number>(0);
  const contentRef = useRef<HTMLIonContentElement>(null);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<string>();

  React.useEffect(() => {
    setRefreshIFrame(randomNumberInRange(1, 1000000));
    const params = new URLSearchParams(search);
    const clientId =  params.get("clientId");
    const token =  params.get("token");
    window.history.pushState({}, "", "/onlineodeme/tahsilet");

    tahsilatService
      .getBorcTutar(clientId!, token!, params.get("borcId")?.split(","))
      .then((tutar: number) => {
        setSelectedBorc(params.get("borcId")?.replaceAll(",", " "));
        setOdenecekGenelToplam(tutar);
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.error(error.response.data);
          console.error(error.response.status);
          console.error(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.error(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error", error.message);
        }
        setShowToastMessage(
          error.response ? error.response.data.message : error
        );
      })
      .finally(() => setShowLoading(false));
  }, [search]);

  const formatCurrency = (value: number | undefined) => {
    if (!value) {
      value = 0;
    }
    return (
      <NumericFormat
        value={value}
        displayType="text"
        thousandSeparator="."
        decimalSeparator=","
        suffix="₺"
        decimalScale={2}
        fixedDecimalScale
      />
    );
  };

  return (
    <IonPage>
      <IonHeader translucent>
        <IonToolbar>
          <IonTitle
            className={`ion-text-sm-wrap ion-no-padding ${
              isPlatform("ios") && "ion-padding-start ion-margin-start"
            }`}
          >
            <IonItem>
              <IonAvatar>
                <img src={logo} alt="Kurum Logosu" title="Kurum Logosu" />
              </IonAvatar>
              <IonLabel className="ion-padding-start">Borç Ödeme</IonLabel>
            </IonItem>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent ref={contentRef} scrollEvents={true}>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={showToastMessage !== undefined}
          onDidDismiss={() => setShowToastMessage(undefined)}
          message={showToastMessage}
          duration={5000}
          position="top"
        />
        <IonCard>
          <IonCardHeader>
            <IonLabel className="ion-text-end ion-padding-end">
              TOPLAM ÖDENECEK MİKTAR: {formatCurrency(odenecekGenelToplam)}
            </IonLabel>
          </IonCardHeader>
          <IonCardContent>
            <iframe
              id="iframe3dpayment"
              title="iframe3dpayment"
              key={refreshIFrame}
              onLoad={(e: any) => {
                // e.preventDefault();
                const freym: any = document.getElementById("iframe3dpayment");
                const msg =
                  kurumBilgileri?.banka === "ipay3d"
                    ? {
                        selectedBorcs: selectedBorc,
                        odenecekGenelToplam: odenecekGenelToplam.toFixed(2),
                        EnrollmentUrl: CARD_ENROLLMENT_URL,
                      }
                    : {
                        sanalPosUrl: kurumBilgileri?.sanalPosUrl,
                        eBelediyeClientId: kurumBilgileri?.eBelediyeClientId,
                        kurumTanim: kurumBilgileri?.kisaTanim,
                        rnd: tahsilat?.rnd,
                        oid: tahsilat?.oid,
                        selectedBorcs: selectedBorc,
                        hash: tahsilat?.hash,
                        sanalPosTip: kurumBilgileri?.sanalPosTip,
                        odenecekGenelToplam: odenecekGenelToplam.toFixed(2),
                        TAHSILAT_BASARILI: TAHSILAT_BASARILI_ONLINEODEME,
                        TAHSILAT_BASARISIZ: TAHSILAT_BASARISIZ,
                        HASH_URL: HASH_URL,
                      };
                freym.contentWindow.postMessage(msg, "*");
              }}
              name="iframe3dpayment"
              width="100%"
              height="450em"
              src={
                kurumBilgileri?.banka === "ipay3d"
                  ? "/payment_ipay.html"
                  : "/payment.html"
              }
              frameBorder="0"
            ></iframe>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default OnlineBorcOdeme;
